import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { LoginDevComponent } from './login/login-dev.component';
import { LoginCASComponent } from './login/login-cas.component';
import { UsuarioscexvegEditComponent } from './usuarioscexveg/usuarioscexveg-edit.component';
import { UsuarioscexvegListComponent } from './usuarioscexveg/usuarioscexveg-list.component';
import { UsuariosexternosEditComponent } from './usuariosexternos/usuariosexternos-edit.component';
import { UsuariosexternosListComponent } from './usuariosexternos/usuariosexternos-list.component';
import { UsuariosMigracionListComponent } from './usuariosmigracion/usuariosmigracion-list.component';
import { BulkCasListComponent } from './bulkcas/bulkcas-list.component';
import { UsuariosService } from './usuarios.service';
import { UsuariosRoutingModule } from './usuarios-routing.module';

@NgModule({
    declarations: [
        LoginDevComponent,
        LoginCASComponent,
        UsuarioscexvegEditComponent,
        UsuarioscexvegListComponent,
        UsuariosexternosEditComponent,
        UsuariosexternosListComponent,
        UsuariosMigracionListComponent,
        BulkCasListComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, UsuariosRoutingModule],
    providers: [UsuariosService],
})
export class UsuariosModule {}
